/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import * as React from "react";
import "./CurveParameterMatrix.scss";
import { BodyText, Grid, Heading, Paper } from "@vaisala-rockhopper/components";
import { useTranslation } from "react-i18next";
import { CurveData } from "../../../../modules/ChemicalDataController";
import _ from "lodash";

interface CurveParameterMatrixProps {
  curveInformation: CurveData;
}

const CurveParameterMatrix = ({
  curveInformation,
}: CurveParameterMatrixProps) => {
  const { t } = useTranslation();

  const [parameterMatrix, setParameterMatrix] = React.useState<
    Array<{ label: string; value: string }>
  >([]);

  //   console.log(curveInformation)

  React.useEffect(() => {
    const newMatrix: any = [];
    for (var i in curveInformation.parameter_matrix) {
      for (var j in curveInformation.parameter_matrix[i]) {
        const val = curveInformation.parameter_matrix[i][j]["value"];
        const label = curveInformation.parameter_matrix[i][j]["label"];
        const numberValue =
          val >= 0
            ? val.length > 9
              ? _.round(val, 5)
              : _.padEnd(val, 9, "0")
            : _.padEnd(
                _.round(
                  val,
                  10 - val.replace(",", ".").split(".")[0].length
                ).toString(),
                10,
                "0"
              ); // Only show 8 numbers. Checking if negative number and rounds or adds trailing zeros when needed.
        newMatrix.push({ label: label, value: numberValue });
      }
    }
    setParameterMatrix(newMatrix);
  }, [curveInformation]);

  if (curveInformation) {
    return (
      <Paper className="curve-parameter-matrix">
        <Heading level={3}>{t("card.parameter_matrix_c")}</Heading>
        <Grid>
          <Grid.Row>
            {parameterMatrix.map((parameter, i) => (
              <Grid.Col key={i} xs={3} sm={3} md={3} lg={3} xl={3}>
                <BodyText>
                  <span className="small">{parameter.label}</span>
                  <br />
                  {parameter.value}
                </BodyText>
              </Grid.Col>
            ))}
          </Grid.Row>
        </Grid>
      </Paper>
    );
  } else return null;
};
export default CurveParameterMatrix;
